import { testTakerHooks } from "pages/School/CreateTestTaker"
import { useCallback, useContext, useMemo, useState } from "react"
import { SchoolContext } from "../SchoolContext"
import { useMutation } from "@tanstack/react-query"
import { deleteLearningUnitFetch, deleteTClassFetch, updateOrCreateTestTakersFetch } from "store/middlewares/testTakers.crud"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { schoolHooks } from ".."
import { Button, UploadFile } from "components/Form"
import { LightButton } from "styles/GlobalStyle"
import { ReactComponent as DeleteIcon } from 'assets/icons/Delete.svg';
import { ReactComponent as Download2Icon } from 'assets/icons/Download2.svg';
import { SvgIcon } from "@mui/material"
import { Add } from "@mui/icons-material"
import { dark } from "styles/theme"
import { map } from 'lodash'
import allClassess from "mock/classess"
import { features, roles } from "keys"
import { permissions } from "config/ability"

const useClassHeaderBtns = (learningUnit, learningUnitKey) => {
    const { affiliation, schoolClassGrades, gradeOpen,learningGroups } = useContext(SchoolContext)
    const [file, setFile] = useState(null)

    const createTestTakerAlert = testTakerHooks.useAlert()
    const currentGrade = schoolClassGrades?.data?.find(item => item.id == gradeOpen) || []
    const downloadStudentFileAlert = schoolHooks.useDownloadStudentFileAlert()
    const isSchoolGroup = learningUnitKey == 'school_class'

    const { mutateAsync: removeUnit } = useMutation({
        mutationFn: deleteLearningUnitFetch,
        onError: (err) => {
            if (err.status == 400)
                toast.error("לא ניתן למחוק כיתה/קבוצה שמשוייך אליה תלמידים", toastConfig)
        },
        onSuccess: () => {
            if (isSchoolGroup)
                schoolClassGrades.refetch()
            else learningGroups.refetch()
            toast(isSchoolGroup ? 'הכיתה הוסרה בהצלחה' : "הקבוצה הוסרה בהצלחה", toastConfig)
        }
    })

    const addTestTaker = useCallback(() => {
        createTestTakerAlert(true, {

            // אנחנו מעבירים את המידע על כיתת האם של התלמיד
            home_affiliation: affiliation.data,
            home_grade: learningUnit?.grade,
            home_class: isSchoolGroup && allClassess.find(item => item.name == learningUnit.name)?.id,

            // מעבירים את המידע על סוג השיוך האם הוא בית ספרי או מסגרת חיצונית וכן את מזהה הכיתה/כיתה חיצונית
            learningUnitType: learningUnitKey,
            learningUnit: learningUnit

            // // school: affiliation.data?.id,
            // grade: currentGrade?.id,
            // home_class: allClassess.find(item => item.name == learningUnit.name)?.id,
            // home_school:

            //     school_class: allClassess.find(item => item.name == learningUnit.name)?.id,
            // learning_group: learningUnit
        })
    }, [affiliation, currentGrade, learningUnit, learningUnitKey])

    const downloadEmptyFile = async (values) => {
        const response = await fetch(
            'https://docs.google.com/spreadsheets/d/15RFaNqZRXcI_ToLLI2q9WOyHJgbC5CrM/export?format=xlsx'
        )

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        const affiliationName = affiliation.data.name.replace(/[<>:"/\\|?*]/g, '');
        link.download = `${affiliationName} ${values.grade.name}${values.school_class.name}.xlsx`;

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
    };

    const openDownloadFileAlert = useCallback(() => {
        const classDetails = {
            school: affiliation.data,
            grade: currentGrade,
            school_class: allClassess.find(item => item.name == learningUnit.name)
        }
        downloadEmptyFile(classDetails)
        downloadStudentFileAlert(true)
    }, [])

    const { mutateAsync: updateOrCreateTestTakers, isPending: uploadFileLoading } = useMutation({
        mutationFn: updateOrCreateTestTakersFetch,
        onSuccess: () => {
            schoolClassGrades.refetch()
            toast("התלמידים התווספו בהצלחה", toastConfig)
        },
        onError: ({ response }) => {
            setFile(null)
            if (response.status == 400)
                toast.error('נראה שהקובץ שאת מנסה להעלות הוא לא של הכיתה הזאת', toastConfig)
        }
    })

    const uploadFile = useCallback((file) => {
        setFile(file)

        let formData = {}
        formData.learning_unit_id = learningUnit.id
        formData.test_takers_file = file
        updateOrCreateTestTakers(formData)
    }, [])

    const classHeaderBtns = {
        removeUnit: {
            label: isSchoolGroup ? "מחיקת כיתה" : "מחיקת קבוצה",
            action: () => removeUnit(learningUnit.id),
            size: "small",
            icon: <SvgIcon fontSize="small" component={DeleteIcon} inheritViewBox />,

            feature: features.school_setup,
            role: permissions.read,
            permissionHOC: "hidden",
        },
        addTestTaker: {
            label: "הוספת תלמיד",
            action: addTestTaker,
            size: "small",
            feature: features.test_takers,
            role: permissions.read,
            icon: <Add fontSize="small" />
        },
        downloadTestTakersFile: {
            label: "הורדת קובץ פרטי תלמידים בפורמט GO",
            action: openDownloadFileAlert,
            size: "small",
            icon: <SvgIcon color={dark} fontSize="small" component={Download2Icon} inheritViewBox />,

            feature: features.school_setup,
            role: permissions.read,
            permissionHOC: "hidden",
        },
        uploadTestTakerFile: {
            placeholder: "העלאת קובץ exel מלא בפורמט GO",
            component: UploadFile,
            buttonComponent: LightButton,
            showCleanIcon: true,
            input: {
                value: file,
                onChange: uploadFile
            },
            type: "exel",
            loading: uploadFileLoading,
            size: "small",

            feature: features.school_setup,
            role: permissions.read,
            permissionHOC: "hidden",
        }
    }

    return isSchoolGroup ? map(classHeaderBtns) : [classHeaderBtns.removeUnit, classHeaderBtns.addTestTaker]
}

export default useClassHeaderBtns